import React from 'react';
import PropTypes from 'prop-types';

import PageSection from '../components/PageSection';
import ScienceIcon from '../components/icons/ScienceIcon';
import phrasesPropType from '../proptypes/phrases';

const AttributesScienceSection = ({ phrases, sciencePath }) => (
  <PageSection theme="black" className="attributes-science">
    <div className="row justify-content-center">
      <div className="col-12 col-lg-5 text-center">
        <ScienceIcon />
        <h3 className="attributes-science__title mt-2 mb-3">{phrases.theScienceTitle}</h3>
        <p className="attributes-science__description mb-3">{phrases.theScienceDescription}</p>
      </div>
    </div>
    <div className="row justify-content-center">
      <div className="col-8 col-lg-4 text-center">
        <a className="attributes-science__link" href={sciencePath}>{phrases.theScienceLearnMore}</a>
      </div>
    </div>
  </PageSection>
);

AttributesScienceSection.propTypes = {
  sciencePath: PropTypes.string.isRequired,
  phrases: phrasesPropType.isRequired,
};

export default AttributesScienceSection;
